/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Delete_Dialog_DeletingInputs */

const en_ui_delete_dialog_deleting = /** @type {(inputs: Ui_Delete_Dialog_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

const de_ui_delete_dialog_deleting = /** @type {(inputs: Ui_Delete_Dialog_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gelöscht...`)
};

/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Ui_Delete_Dialog_DeletingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_delete_dialog_deleting = /** @type {((inputs?: Ui_Delete_Dialog_DeletingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Delete_Dialog_DeletingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_delete_dialog_deleting(inputs)
	return de_ui_delete_dialog_deleting(inputs)
});